import { getLinkVersion, getSuccessPayload } from '../../sdk-interface';
import { selectLinkApiResponse } from '../../state/slices/slice-link-api';
import { tokenHasJob } from '../../utils';
import eventQueue from '../queue';
function attachEventListener() {
    eventQueue.on('state', function (_a) {
        var action = _a.action, fireClientEvent = _a.fireClientEvent, state = _a.state;
        if (action === 'linkApi/waitForJobStepsResults/fulfilled' ||
            action === 'linkApi/next/fulfilled' ||
            action === 'linkApi/initializeLogin/fulfilled') {
            var isSuccess = selectLinkApiResponse(state).responseType === 'success';
            if (!isSuccess)
                return;
            var hasDdsJob = tokenHasJob(state.linkParams.linkTokenPayload, 'direct_deposit_switch');
            // We are firing login events here to ensure the order is correct (i.e. login fires BEFORE success always)
            if (state.linkApi.jobType === 'login') {
                fireClientEvent('login', {
                    platformId: state.linkApi.context.platform.id,
                    accountId: state.linkApi.accountId,
                });
            }
            if (hasDdsJob && state.linkApi.jobType === 'login')
                return;
            fireClientEvent('success', getSuccessPayload(getLinkVersion(), state));
        }
    });
}
attachEventListener();
